import axios from "axios"
import {getStationCode} from "../../network/NetworkUtil";
import {
    convertSecondsToTimeFormat,
    formatAlias,
    getDateInMMDDYYYYWithOffset,
    sortList
} from "../../util/Util";
import {
    ASSOCIATE_TAB_METRIC_KEY,
    ERROR_COUNT_METRIC,
    GLOBAL_METRIC_KEY,
    logErrorMetric,
    logOperationalMetric,
    MetricType,
    RSWS_ASSOCIATE_METRIC,
    RSWS_ROUTE_LIST_METRIC
} from "../../util/MetricUtil";
import {NO, SORT_DIRECTION, TIMEOUTS, YES} from "../../util/Constants";
import {Logger} from "../../util/Logger";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";

export function fetchAssociateMetricsV2(dispatcher, baseUrl, stationConfig) {
    getAssociateMetricsFromStationRoutes(dispatcher, baseUrl, stationConfig)
}

async function getAssociateMetricsFromStationRoutes(dispatcher, baseUrl, stationConfig) {
    try {
        const response = await getStationRoutes(baseUrl, stationConfig);
        let output = response && response.status === 200 ? response.data.routes : [];
        const result = getOutboundAssociateMetrics(output);
        dispatcher({type: "RECEIVE_DATA", data: result});
    } catch (error) {
        Logger.error("Exception in AssociateNetworkAPI.getAssociateMetricsFromRSWS", error);
        logErrorMetric(getStationCode(), GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }
}

//Currently we have re-used the same API of RSWS (GetStationRoutesV2) but that might change in future based on requirement

async function getStationRoutes(baseUrl, stationConfig) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_GET_STATION_ROUTES_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestBody = {
                "date": [getDateInMMDDYYYYWithOffset(0)]
            }
            const requestPayload = {
                resourcePath: "/apigw/route/station/" + stationCode,
                httpMethod: "get",
                processName: "routeStaging",
                requestParams: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get("/rsws/route/station/" + stationCode + "?date=" + getDateInMMDDYYYYWithOffset(0));
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, ASSOCIATE_TAB_METRIC_KEY, RSWS_ASSOCIATE_METRIC, MetricType.SUCCESS);
            console.log("Initial Picklist: ",response);
            return response;
        } else {
            var error = {
                response : response
            }
            logOperationalMetric(startTime, stationCode, ASSOCIATE_TAB_METRIC_KEY, RSWS_ASSOCIATE_METRIC, MetricType.FAILED, error);
        }
    } catch (e) {
        Logger.error("Exception in AssociateNetworkAPI.getStationRoutes", e);
        logOperationalMetric(startTime, stationCode, ASSOCIATE_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, e);
    }
    return null;
}

function getOutboundAssociateMetrics(routes) {
    let allPicklists = [];

    routes.forEach(route => {
        if (route.picklists) {
            route.picklists.forEach(picklist => {
                if (picklist.associates) {
                    picklist.associates.forEach(associate => {
                        addAssociatePicklists(associate, picklist, allPicklists, route);
                    });
                }
            })
        }
    });



    const associateMap = allPicklists.reduce((map, picklist) => {
        if (map[picklist.alias]) {
            if (picklist.startTime < map[picklist.alias].minStartTime) {
                map[picklist.alias].minStartTime = picklist.startTime;
            }
            if (picklist.endTime > map[picklist.alias].maxEndTime) {
                map[picklist.alias].maxEndTime = picklist.endTime;
                map[picklist.alias].lastStatus = picklist.status;
            }
            map[picklist.alias].totalDuration = picklist.duration + map[picklist.alias].totalDuration;
            map[picklist.alias].picklists.push(picklist);
        } else {
            map[picklist.alias] = {
                ...picklist,
                picklists: [picklist],
                totalDuration: picklist.duration,
                minStartTime: picklist.startTime,
                maxEndTime: picklist.active ? null : picklist.endTime,
            }
        }
        return map;
    }, {});

    const associatePerformance = Object.values(associateMap).map(mapping => {
        const isActive = mapping.active;
        const totalIdleTimeInSeconds = calculateTotalIdleTimeOfAssociate(mapping.picklists);

        return {
            ...mapping,
            active: isActive ? YES : NO,
            routeCode: mapping.routeCode,
            startTime: mapping.startTime,
            endTime: mapping.endTime,
            totalIdleTimeInSeconds: totalIdleTimeInSeconds,
            totalIdleTime: isActive ? "-" : (totalIdleTimeInSeconds > 0 ? convertSecondsToTimeFormat(totalIdleTimeInSeconds) : "-"),
            lastActivityTime: convertSecondsToTimeFormat(mapping.lastActivityTime / 1000),
            sourceLocation: mapping.sourceLocation,
            stagingDuration: isActive ? convertSecondsToTimeFormat(mapping.stagingDuration / 1000) : "-"
        }
    });
    return {
        associatePerformance
    }
}

function addAssociatePicklists(associate, picklist, allPicklists, route) {
    if (associate.latest) {
        allPicklists.push({
            alias: formatAlias(associate.alias),
            active: associate.active,
            startTime: associate.startTime,
            endTime: associate.active ? null : associate.endTime,
            lastActivityTime: associate.lastActivityTime,
            routeCode: route.routeCode,
            stagedTime: associate.stagedTime,
            sourceLocation: associate.sourceLocation,
            stagingLocation: route.stagingLocation,
            status: picklist.status,
            stagingDuration: associate.stagingDuration
        });
    }
}


const IDLE_THRESHOLD_MS = 3 * 60 * 1000;

function calculateTotalIdleTimeOfAssociate(picklists) {
    let totalIdleTime = 0;
    if (Array.isArray(picklists) && picklists.length > 0) {
        const sortedList = sortList(picklists, "startTime", SORT_DIRECTION.ASC);

        sortedList.forEach(picklist => {
            if (!picklist.active && picklist.stagedTime) {
                const idleDurationInMs = Date.now() - picklist.stagedTime;

                if (idleDurationInMs > IDLE_THRESHOLD_MS) {
                    totalIdleTime += (idleDurationInMs - IDLE_THRESHOLD_MS) / 1000;  // Convert to seconds
                }
            }
        });
    }
    return totalIdleTime;
}






// WEBPACK FOOTER //
// ./src/components/outboundassociate/network/AssociateNetworkAPIV2.js